import React from "react";

const RangeSingleSelector = ({ numDays, rangeCallback, len }) => (
  <div
    className={"clickable" + (len === numDays ? " bold" : "")}
    onClick={() => rangeCallback(numDays)}
  >
    {numDays} days
  </div>
);

// Custom tooltip component
const RangeSelector = ({ rangeCallback, len }) => (
  <div className="rangeSelector">
    <RangeSingleSelector numDays={14} rangeCallback={rangeCallback} len={len} />
    <RangeSingleSelector numDays={30} rangeCallback={rangeCallback} len={len} />
    <RangeSingleSelector numDays={60} rangeCallback={rangeCallback} len={len} />
    <RangeSingleSelector numDays={90} rangeCallback={rangeCallback} len={len} />
  </div>
);

export default RangeSelector;
